// @flow
import {createSelector} from "reselect";
import isEmpty from "lodash/isEmpty";
import CurrentRequestSelectors from "../CurrentRequest/selectors";
import type {State} from "../../Store";
import ServiceConfigSelectors from "../ServiceConfig/selectors";
import TokenDataSelectors from "../TokenData/selectors";
import {LatLngEnum} from "../../../Utils/AppUtils";

const currentProposalSelector = (state: State) => state.currentProposal;

const getProposalPickup = createSelector(
    currentProposalSelector,
    (currentProposal) => {
        return currentProposal.pickup_location;
    }
);

const getProposalDropoff = createSelector(
    currentProposalSelector,
    CurrentRequestSelectors.getDest,
    (currentProposal, dest) => {
        return {
            ...currentProposal.dropoff_location,
            address: dest.address
        };
    }
);

const proposalETA = createSelector(
    currentProposalSelector,
    (currentProposal) => {
        return currentProposal.eta;
    }
);

const isProposalValid = createSelector(
    currentProposalSelector,
    (currentProposal) => {
        return currentProposal.valid;
    }
);

const isProposalAccepted = createSelector(
    currentProposalSelector,
    (currentProposal) => {
        return currentProposal.accepted;
    }
);

const getProposalTimestamp = createSelector(
    currentProposalSelector,
    (currentProposal) => {
        return currentProposal.timestamp;
    }
);

const getProposalID = createSelector(
    currentProposalSelector,
    (currentProposal) => {
        return currentProposal.proposal_id;
    }
);

const isConcreteProposal = createSelector(
    currentProposalSelector,

    (currentProposal) => {
        return (currentProposal && !isEmpty(currentProposal));
    },
);

const shouldRequestProposal = createSelector(
    CurrentRequestSelectors.currentRequestSelector,
    isConcreteProposal,
    CurrentRequestSelectors.isOriginSelected,
    CurrentRequestSelectors.isDestSelected,

    (currentRequest, showProposalDetails, originSelected, destSelected) => {
        return (currentRequest && originSelected && destSelected && !showProposalDetails);
    },
);

const canRequestRide = createSelector(
    isConcreteProposal,
    ServiceConfigSelectors.serviceConfigSelector,
    TokenDataSelectors.tokenDataSelector,

    (concreteProposal, serviceConfig, tokenData) => {
        return (!concreteProposal && serviceConfig && tokenData);
    },
);

const canRequestOrigin = createSelector(
    canRequestRide,
    CurrentRequestSelectors.isOriginSelected,
    TokenDataSelectors.getOriginType,

    (requestRide, originSelected, originType) => {
        return requestRide && !originSelected && (originType !== LatLngEnum.FORCE_EXACT);
    }
);

const canRequestDest = createSelector(
    canRequestRide,
    CurrentRequestSelectors.isOriginSelected,
    CurrentRequestSelectors.isDestSelected,
    TokenDataSelectors.getDestType,
    (requestRide, originSelected, destSelected, destType) => {
        //TODO(Oded): this assumes destination is always chosen after origin
        return requestRide && originSelected && !destSelected && (destType !== LatLngEnum.FORCE_EXACT);
    },
);

export default {
    currentProposalSelector,
    getProposalPickup,
    getProposalDropoff,
    proposalETA,
    isProposalValid,
    isProposalAccepted,
    getProposalTimestamp,
    getProposalID,
    isConcreteProposal,
    shouldRequestProposal,
    canRequestRide,
    canRequestOrigin,
    canRequestDest,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentProposal/selectors.js